import { FilterField } from '@totem/components/ui_components/reportSettings/types';

export const logSyncContainerConfiguration: FilterField[] = [
  {
    key: 'name',
    label: 'Name',
    sortField: 'name',
    filterField: 'name',
    multiple: true,
    values: [],
  },
  {
    key: 'connection',
    label: 'Connection',
    sortField: 'item.connection.name',
    filterField: 'item.connection.name',
    multiple: true,
    values: [],
  },
  {
    key: 'site',
    label: 'Site',
    sortField: 'item.site.name',
    filterField: 'item.site.name',
    multiple: true,
    values: [],
  },
  {
    key: 'createdAt',
    label: 'Created At',
    sortField: 'createdAt',
    filterField: '',
    multiple: false,
    values: [],
  },
];
